export { SpaTreatmentsV2Connected as SpaTreatmentsV2 } from './container';
